import React from 'react';
import {Scrollbars} from 'react-custom-scrollbars';
import Navigation from "./navigation/Navigation";


class Sidebar extends React.Component {

    constructor(props) {
        super(props);
        this.renderThumb = this.renderThumb.bind(this);
        this.state = {
            scrollHeight: window.innerHeight - 182
        };

        window.onresize = () => {
            this.setState({scrollHeight: window.innerHeight - 182});
        };
    }

    renderThumb({ style, ...props }) {
        const thumbStyle = {
            backgroundColor: 'rgb(158, 165, 171)',
            borderRadius: '7px',
            width: '10px',
            opacity: '0.4',
            position: 'absolute',
            zIndex: '99',
            right: '0.5px',
            top: '0'
        };
        return (
            <div
                style={{ ...style, ...thumbStyle }}
                {...props}/>
        );
    }

    render() {
        return (
            <div>
                <Scrollbars
                    style={{height: this.state.scrollHeight,}}
                    renderThumbVertical={this.renderThumb}
                    autoHide={true}
                >
                    <Navigation/>
                    <div className="clearfix"/>
                </Scrollbars>
            </div>
        );
    };
}

export default Sidebar;




// WEBPACK FOOTER //
// ./web/src/components/Sidebar.jsx